import { Outlet, Navigate } from 'react-router-dom'
import React from 'react';

const HackathonRoutes = () => {
    const isHackathonHome = window.location.hostname === "ecoinnovators.grovator.com";
    return (
        isHackathonHome ? <Navigate to="/" /> : <Outlet />
    )
}

export default HackathonRoutes;